import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTalksAction } from '../../../utils/redux/talks/talksAction';
import { Container, Table, Badge, Form, Row, Col, InputGroup, Button, Card } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import './Talkpage.css';
import { fetchAllCategories } from '../../../utils/redux/category/categoryAction';
import AddTalkModal from '../../modals/AddTalkModal';
import CategoryModal from '../../modals/CategoryModal';
import '../CSS/common.css';

const Talkpage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { talks, isLoading, totalTalks, totalPages } = useSelector((state) => state.talks);
    const { categories } = useSelector((state) => state.category);
    const [params] = useSearchParams();

    // Search and filter states
    const [searchQuery, setSearchQuery] = useState(params.get('searchQuery') ? params.get('searchQuery') : '');
    const [searchBy, setSearchBy] = useState(params.get('searchBy') ? params.get('searchBy') : '');
    const [category, setCategory] = useState(params.get('category') ? params.get('category') : '');
    const [talkYear, setTalkYear] = useState('');
    const [sortBy, setSortBy] = useState('talkDate');
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(params.get('page') ? parseInt(params.get('page')) : 1);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showCatModal, setShowCatModal] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [summaryExist, setSummaryExist] = useState(params.get('summaryExist') ? params.get('summaryExist') : '');
    const [summaryAssignmentStatus, setSummaryAssignmentStatus] = useState(params.get('summaryAssignmentStatus') ? params.get('summaryAssignmentStatus') : '');

    // Remove debounce effect
    useEffect(() => {
        const param = {
            search: searchQuery,
            searchBy: searchBy,
            category: category,
            talkYear: talkYear,
            sortBy: sortBy,
            limit: limit,
            page: params.get('page') ? parseInt(params.get('page')) : page,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        };
        dispatch(fetchAllTalksAction(param));
        dispatch(fetchAllCategories());
    }, []);

    const handleResetFilters = () => {
        setCategory('');
        setSearchBy('');
        setSearchQuery('');
        setPage(1);
        setTalkYear('');
        setStartDate('');
        setEndDate('');
        setSummaryExist('');
        setSummaryAssignmentStatus('');
        navigate(`/talks?page=1`)
        dispatch(fetchAllTalksAction());
    }

    const handlePageChange = (page) => {
        setPage(page);
        navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${endDate}&page=${page}`)
        const param = {
            search: searchQuery,
            searchBy: searchBy,
            category: category,
            talkYear: talkYear,
            sortBy: sortBy,
            limit: limit,
            page: page,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        };
        dispatch(fetchAllTalksAction(param));
    };

    // Handle search on enter press
    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${endDate}&page=${1}`)
            setPage(1)
            const param = {
                search: searchQuery,
                searchBy: searchBy,
                category: category,
                talkYear: talkYear,
                sortBy: sortBy,
                limit: limit,
                page: 1,
                startDate: startDate,
                endDate: endDate,
                summaryExist: summaryExist,
                summaryAssignmentStatus: summaryAssignmentStatus
            };
            dispatch(fetchAllTalksAction(param));
        }
    };


    const handleSearchButtonClick = (e) => {
        navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${endDate}&page=${1}`)
        setPage(1)
        const param = {
            search: searchQuery,
            searchBy: searchBy,
            category: category,
            talkYear: talkYear,
            sortBy: sortBy,
            limit: limit,
            page: 1,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        };
        dispatch(fetchAllTalksAction(param));
    };

    // Handle category change
    const handleCategoryChange = (e) => {
        setCategory(e.target.value);
        navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${e.target.value}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${endDate}&page=${1}`)
        setPage(1)
        dispatch(fetchAllTalksAction({
            search: searchQuery,
            searchBy: searchBy,
            category: e.target.value,
            talkYear: talkYear,
            sortBy: sortBy,
            limit: limit,
            page: 1,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        }));
    };

    // Add new handler for sorting
    const handleSortChange = (e) => {
        setSortBy(e.target.value);
        setPage(1)
        dispatch(fetchAllTalksAction({
            search: searchQuery,
            searchBy: searchBy,
            category: category,
            talkYear: talkYear,
            sortBy: e.target.value,
            limit: limit,
            page: 1,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        }));
    };

    // Add new handler for year filter
    const handleYearChange = (e) => {
        setTalkYear(e.target.value);
        setPage(1)
        dispatch(fetchAllTalksAction({
            search: searchQuery,
            searchBy: searchBy,
            category: category,
            talkYear: e.target.value,
            sortBy: sortBy,
            limit: limit,
            page: 1,
            startDate: startDate,
            endDate: endDate,
            summaryExist: summaryExist,
            summaryAssignmentStatus: summaryAssignmentStatus
        }));
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
        });
    };

    const getPageNumbers = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

        if (current <= 4) {
            return [1, 2, 3, 4, 5, '...', total];
        }

        if (current >= total - 3) {
            return [1, '...', total - 4, total - 3, total - 2, total - 1, total];
        }

        return [1, '...', current - 1, current, current + 1, '...', total];
    };

    if (isLoading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    return (
        <Container className="py-4">
            {/* <h2 className="mb-4">Available Talks</h2> */}

            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                <h2 className="mb-0">Available Talks</h2>
                <div className="d-flex gap-2">
                    <Button variant="primary" onClick={() => setShowAddModal(true)}>
                        + Add Talk
                    </Button>
                    <Button variant="outline-primary" onClick={() => setShowCatModal(true)}>
                        Manage Categories
                    </Button>
                </div>
            </div>

            {/* Update Search and Filter Section */}

            <Card className="mb-4 shadow-sm border-0">
                <Card.Body>
                    <Row className="gy-3 gx-3 align-items-end">
                        <Col md={3} xs={12}>
                            <Form.Label htmlFor="searchInput" className="fw-semibold">Search</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    id="searchInput"
                                    placeholder="Search talks..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyPress={handleSearch}
                                />
                                <Form.Select
                                    value={searchBy}
                                    onChange={(e) => setSearchBy(e.target.value)}
                                    style={{ maxWidth: 140 }}
                                >
                                    <option value="">All fields</option>
                                    <option value="title">Title</option>
                                    <option value="description">Description</option>
                                    <option value="tags">Tags</option>
                                    <option value="keywords">Keywords</option>
                                </Form.Select>
                            </InputGroup>
                            <Button
                                className='mt-2'
                                onClick={handleSearchButtonClick}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">Category</Form.Label>
                            <Form.Select
                                value={category}
                                onChange={handleCategoryChange}
                            >
                                <option value="">All Categories</option>
                                {categories?.map(cat => (
                                    <option key={cat._id} value={cat._id}>{cat?.name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">Sort By</Form.Label>
                            <Form.Select
                                value={sortBy}
                                onChange={handleSortChange}
                            >
                                <option value="talkDate">Date</option>
                                <option value="title">Title</option>
                                <option value="duration">Duration</option>
                            </Form.Select>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">Summary</Form.Label>
                            <Form.Select
                                value={summaryExist}
                                onChange={e => {
                                    setSummaryExist(e.target.value);
                                    setPage(1);
                                    navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${e.target.value}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${endDate}&page=${1}`)
                                    dispatch(fetchAllTalksAction({
                                        search: searchQuery,
                                        searchBy: searchBy,
                                        category: category,
                                        talkYear: talkYear,
                                        sortBy: sortBy,
                                        limit: limit,
                                        page: 1,
                                        startDate: startDate,
                                        endDate: endDate,
                                        summaryExist: e.target.value
                                    }));
                                }}
                            >
                                <option value="">All</option>
                                <option value="true">Exists</option>
                                <option value="false">Not Exists</option>
                            </Form.Select>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">Summary Task</Form.Label>
                            <Form.Select
                                value={summaryAssignmentStatus}
                                onChange={e => {
                                    setSummaryAssignmentStatus(e.target.value);
                                    setPage(1);
                                    navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${e.target.value}&startDate=${startDate}&endDate=${endDate}&page=${1}`)
                                    dispatch(fetchAllTalksAction({
                                        search: searchQuery,
                                        searchBy: searchBy,
                                        category: category,
                                        talkYear: talkYear,
                                        sortBy: sortBy,
                                        limit: limit,
                                        page: 1,
                                        startDate: startDate,
                                        endDate: endDate,
                                        summaryExist: summaryExist,
                                        summaryAssignmentStatus: e.target.value
                                    }));
                                }}
                            >
                                <option value="">All</option>
                                <option value="ASSIGNED">Assigned</option>
                                <option value="COMPLETED">Completed</option>
                            </Form.Select>
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={e => {
                                    setStartDate(e.target.value);
                                    setPage(1);
                                    navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${e.target.value}&endDate=${endDate}&page=${1}`)
                                    if (e.target.value && e.target.value.length === 10) {
                                        dispatch(fetchAllTalksAction({
                                            search: searchQuery,
                                            searchBy: searchBy,
                                            category: category,
                                            talkYear: talkYear,
                                            sortBy: sortBy,
                                            limit: limit,
                                            page: 1,
                                            startDate: e.target.value,
                                            endDate: endDate,
                                            summaryExist: summaryExist,
                                            summaryAssignmentStatus: summaryAssignmentStatus
                                        }));
                                    }
                                }}
                                placeholder="Start Date"
                            />
                        </Col>
                        <Col md={2} xs={6}>
                            <Form.Label className="fw-semibold">End Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={e => {
                                    setEndDate(e.target.value);
                                    setPage(1);
                                    navigate(`/talks?searchQuery=${searchQuery}&searchBy=${searchBy}&category=${category}&summaryExist=${summaryExist}&summaryAssignmentStatus=${summaryAssignmentStatus}&startDate=${startDate}&endDate=${e.target.value}&page=${1}`)
                                    if (e.target.value && e.target.value.length === 10) {
                                        dispatch(fetchAllTalksAction({
                                            search: searchQuery,
                                            searchBy: searchBy,
                                            category: category,
                                            talkYear: talkYear,
                                            sortBy: sortBy,
                                            limit: limit,
                                            page: 1,
                                            startDate: startDate,
                                            endDate: e.target.value,
                                            summaryExist: summaryExist,
                                            summaryAssignmentStatus: summaryAssignmentStatus
                                        }));
                                    }
                                }}
                                placeholder="End Date"
                            />
                        </Col>
                        <Col md={2} xs={12} className="d-flex gap-2 justify-content-end align-items-center mt-md-0 mt-3">
                            <Button variant="secondary" onClick={handleResetFilters}>
                                Reset
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    <Row className='d-flex flex-row justify-content-start align-items-center fit-content'>
                        <span className='w-auto'>Sheet Link:</span>
                        <a
                            href='https://docs.google.com/spreadsheets/d/12y1STdLQcSm6qXTos24Wl1GkQqc_b0Tk2RzWnhOYMmU/edit?usp=sharing' target='_blank'
                            className='w-auto'
                        >
                            Talks Data Final
                        </a>
                    </Row>
                </Card.Body>
            </Card>

            {/* Update the table structure in the return statement */}
            <div className="d-none d-md-block"> {/* Hide table on mobile */}
                <Table hover responsive className="talk-table">
                    <colgroup>
                        <col style={{ width: '45%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '25%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Date</th>
                            <th>Duration</th>
                            <th>Summary</th>
                            <th>Keywords</th>
                        </tr>
                    </thead>
                    <tbody>
                        {talks?.map((talk) => (
                            <tr
                                key={talk._id}
                                className="talk-row"
                                onClick={() => navigate(`/talks/${talk._id}`)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td>
                                    <div className="title-cell">
                                        <strong title={talk.title}>{talk.title}</strong>
                                    </div>
                                </td>
                                <td>{talk?.talkDate ? formatDate(talk.talkDate) : "No Date Specified"}</td>
                                <td>{talk?.durationHhmmss}</td>
                                <td>{talk?.summaryExist === true ? "Yes" : "No"}</td>
                                <td>
                                    <div className="keywords-cell">
                                        {talk?.keywords?.map((keyword, index) => (
                                            <Badge
                                                key={index}
                                                bg="secondary"
                                                className="me-1 mb-1"
                                                style={{
                                                    maxWidth: '100%',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                                title={keyword}
                                            >
                                                {keyword}
                                            </Badge>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Mobile Card View */}
            <div className="d-md-none"> {/* Show only on mobile */}
                <div className="talk-cards">
                    {talks?.map((talk) => (
                        <div
                            key={talk._id}
                            className="talk-card-mobile"
                            onClick={() => navigate(`/talks/${talk._id}`)}
                        >
                            <h5 className="talk-card-title" title={talk.title}>
                                {talk.title}
                            </h5>
                            <div className="talk-card-meta">
                                <span className="meta-item">
                                    <small className="text-muted">Date:</small> {formatDate(talk?.talkDate)}
                                </span>
                                <span className="meta-item">
                                    <small className="text-muted">Duration:</small> {talk?.durationHhmmss}
                                </span>
                                <span className="meta-item">
                                    <small className="text-muted">Summary:</small> {talk?.summaryExist === true ? "Yes" : "No"}
                                </span>
                            </div>
                            <div className="talk-card-keywords">
                                {talk?.keywords?.map((keyword, index) => (
                                    <Badge
                                        key={index}
                                        bg="secondary"
                                        className="me-1 mb-1"
                                        title={keyword}
                                    >
                                        {keyword}
                                    </Badge>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='d-flex flex-column justify-content-center align-items-center w-100'>
                <div className='mt-1 mb-3'>
                    Showing {(limit * (page - 1)) + 1} - {totalTalks < limit * (page) ? totalTalks : limit * (page)} of {totalTalks} Talks
                </div>
                <div className="pagination-controls">
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(1)}
                        disabled={page === 1 || isLoading}
                    >
                        First
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1 || isLoading}
                    >
                        Previous
                    </button>

                    <div className="page-numbers">
                        {getPageNumbers(page, totalPages).map((pageind, index) => (
                            <React.Fragment key={index}>
                                {pageind === '...' ? (
                                    <span className="pagination-ellipsis">...</span>
                                ) : (
                                    <button
                                        className={`pagination-button ${page === pageind ? 'active' : ''}`}
                                        onClick={() => handlePageChange(pageind)}
                                        disabled={isLoading}
                                    >
                                        {pageind}
                                    </button>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === totalPages || isLoading}
                    >
                        Next
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => handlePageChange(totalPages)}
                        disabled={page === totalPages || isLoading}
                    >
                        Last
                    </button>
                </div>
            </div>
            <AddTalkModal
                show={showAddModal}
                handleClose={() => setShowAddModal(false)}
                categories={categories}
                onSuccess={() => dispatch(fetchAllTalksAction())}
            />
            <CategoryModal show={showCatModal} handleClose={() => setShowCatModal(false)} />
        </Container>
    );
};

// Helper function to generate year options (last 5 years)
const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        years.push(
            <option key={year} value={year}>
                {year}
            </option>
        );
    }
    return years;
};

export default Talkpage;